/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { RouteOfAdministration } from './RouteOfAdministration'
import { SamText } from './SamText'
import { VirtualForm } from './VirtualForm'
import { VirtualIngredient } from './VirtualIngredient'

export class VmpComponent {
  constructor(json: JSON | any) {
    Object.assign(this as VmpComponent, json)
  }

  code?: string
  virtualForm?: VirtualForm
  routeOfAdministrations?: Array<RouteOfAdministration>
  name?: SamText
  phaseNumber?: number
  virtualIngredients?: Array<VirtualIngredient>
}
